import { useTheme } from '@mui/material';
import { useState } from 'react';
import PropTypes from 'prop-types';
import CreateNotice from '../components/CreateNotice';
import NoticeTemplate from '../components/NoticeTemplate';
import TrainingResults from '../components/TrainingResults';
import Accounts from '../components/Accounts';
import DetailTrainingResult from '../components/DetailTrainingResult';
import EditTrainerCheckItems from './EditTrainerCheckItems';
import EditSelfCheckItems from './EditSelfCheckItems';

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import EditNoteIcon from '@mui/icons-material/EditNote';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import Check from '@mui/icons-material/Check';

const TabMenu = (props) => {
  const { palette, typography } = useTheme();
  const accountSettingStyle = { ...typography.label14, marginLeft: 'auto' };

  const CREATE_NOTICE_INDEX = 0;
  const TRAINING_RESULTS_INDEX = 1;
  const ADMIN_MENU_INDEX = 2;
  const ACCOUNT_INDEX = -1;
  const TEMPLATE_INDEX = -2;

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenuItem = Boolean(anchorEl);
  const { loginUser } = props;

  const [selectedTab, setSelectedTab] = useState(CREATE_NOTICE_INDEX);
  const [selectedTrainingResultId, setSelectedTrainingResultId] = useState();
  const [isDetail, setIsDetail] = useState(false);
  const [isEditTrainerCheck, setIsEditTrainerCheck] = useState(false);
  const [isEditSelfCheck, setIsEditSelfCheck] = useState(false);
  const [isAccountTab, setIsAccountTab] = useState(false);
  const [isTemplateTab, setIsTemplateTab] = useState(false);

  // タブをクリックしたとき
  const handleChangeTab = (_, value) => {
    if (value !== ADMIN_MENU_INDEX) {
      setSelectedTab(value);
      setIsAccountTab(null);
      setIsTemplateTab(null);
    }
  };

  // 管理メニューのプルダウンを選択した時
  const handleClickAdminItem = (index) => {
    setAnchorEl(null);
    setSelectedTab(ADMIN_MENU_INDEX);
    setIsAccountTab(index === ACCOUNT_INDEX);
    setIsTemplateTab(index === TEMPLATE_INDEX);
  };

  // トレーニング結果詳細画面へ移動
  const handleMoveToDetailTrainingResult = (id) => {
    setSelectedTrainingResultId(id);
    setIsDetail(true);
  };

  // 指導者チェック項目編集画面へ移動
  const handleMoveToEditTrainerCheck = () => {
    setIsEditTrainerCheck(true);
  };

  // 受講者セルフチェック問題編集画面へ移動
  const handleMoveToEditSelfCheck = () => {
    setIsEditSelfCheck(true);
  };

  // トレーニング結果一覧画面へ移動
  const handleMoveToTrainingResult = () => {
    setIsDetail(false);
    setIsEditTrainerCheck(false);
    setIsEditSelfCheck(false);
  };

  return (
    <>
      <Tabs
        value={selectedTab}
        textColor='inherit'
        onChange={handleChangeTab}
        sx={{ height: '57px', backgroundColor: 'white', borderBottom: `1px solid ${palette.divider}` }}
      >
        <Tab
          sx={typography.label14}
          icon={<EditNoteIcon />}
          iconPosition='start'
          label='通告作成・送信'
        />
        <Tab
          sx={typography.label14}
          icon={<FactCheckOutlinedIcon />}
          iconPosition='start'
          label='トレーニング結果'
          onClick={() => handleMoveToTrainingResult()}
        />
        <Tab
          sx={accountSettingStyle}
          icon={<SettingsOutlinedIcon />}
          iconPosition='start'
          label='管理メニュー'
          id="admin-tab"
          aria-controls={openMenuItem ? 'admin-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={openMenuItem ? 'true' : undefined}
          onClick={(event) => {
            setAnchorEl(event.currentTarget);
          }}
        />
      </Tabs >
      <Menu
        id="admin-menu"
        anchorEl={anchorEl}
        open={openMenuItem}
        onClose={() => {
          setAnchorEl(null);
        }}
        MenuListProps={{ 'aria-labelledby': 'admin-tab' }}
        anchorOrigin={{
          vertical: 55,
          horizontal: 'left',
        }}
      >
        <MenuItem
          sx={typography.label14}
          onClick={() => {
            handleClickAdminItem(ACCOUNT_INDEX);
          }}>
          アカウント管理
          {isAccountTab && <CheckIcon />}
        </MenuItem>
        <MenuItem
          sx={typography.label14}
          onClick={() => {
            handleClickAdminItem(TEMPLATE_INDEX);
          }} >
          通告テンプレート管理
          {isTemplateTab && <CheckIcon />}
        </MenuItem>
      </Menu>

      {/* タブ内コンテンツ */}
      {selectedTab === CREATE_NOTICE_INDEX && <CreateNotice loginUser={loginUser} />}
      {selectedTab === TRAINING_RESULTS_INDEX &&
        isDetail === false && isEditTrainerCheck === false && isEditSelfCheck === false &&
        <TrainingResults
          handleMoveToDetailTrainingResult={handleMoveToDetailTrainingResult}
          handleMoveToEditTrainerCheck={handleMoveToEditTrainerCheck}
          handleMoveToEditSelfCheck={handleMoveToEditSelfCheck}
        />}
      {selectedTab === TRAINING_RESULTS_INDEX && isDetail === true &&
        <DetailTrainingResult
          handleMoveToTrainingResult={handleMoveToTrainingResult}
          selectedTrainingResultId={selectedTrainingResultId}
        />}
      {selectedTab === TRAINING_RESULTS_INDEX && isEditTrainerCheck === true &&
        <EditTrainerCheckItems
          handleMoveToTrainingResult={handleMoveToTrainingResult}
        />}
      {selectedTab === TRAINING_RESULTS_INDEX && isEditSelfCheck === true &&
        <EditSelfCheckItems
          handleMoveToTrainingResult={handleMoveToTrainingResult}
        />}
      {selectedTab === ADMIN_MENU_INDEX && isAccountTab && <Accounts loginUser={loginUser} />}
      {selectedTab === ADMIN_MENU_INDEX && isTemplateTab && <NoticeTemplate />}
    </>
  );
};

const CheckIcon = () => {
  return (
    <ListItemIcon >
      <Check color='primary' sx={{ margin: 'auto' }} />
    </ListItemIcon>
  );
};

export default TabMenu;

TabMenu.propTypes = {
  loginUser: PropTypes.object,
};
